/**
 * РљРѕРЅС„РёРіСѓСЂР°С†РёСЏ Р±СЂРµРЅРґР° Sheriff Barbershop
 * 
 * Р­С‚РѕС‚ С„Р°Р№Р» СЃРѕРґРµСЂР¶РёС‚ РІСЃРµ РїР°СЂР°РјРµС‚СЂС‹ Р±СЂРµРЅРґРёРЅРіР°, РєРѕС‚РѕСЂС‹Рµ РјРѕР¶РЅРѕ Р»РµРіРєРѕ РёР·РјРµРЅРёС‚СЊ
 * РґР»СЏ Р°РґР°РїС‚Р°С†РёРё РїРѕРґ РґСЂСѓРіРѕРіРѕ РєР»РёРµРЅС‚Р° (РјСѓР»СЊС‚Рё-Р±СЂРµРЅРґ Р°СЂС…РёС‚РµРєС‚СѓСЂР°).
 */

export interface BrandConfig {
  // РћСЃРЅРѕРІРЅР°СЏ РёРЅС„РѕСЂРјР°С†РёСЏ
  name: string;
  tagline: string;
  description: string;
  
  // Р›РѕРіРѕС‚РёРїС‹
  logos: {
    horizontal: string;  // РЁРёСЂРѕРєРёР№ Р»РѕРіРѕС‚РёРї РґР»СЏ С€Р°РїРєРё
    square: string;      // РљРІР°РґСЂР°С‚РЅС‹Р№ РґР»СЏ РёРєРѕРЅРѕРє
  };
  
  // Р¦РІРµС‚РѕРІР°СЏ РїР°Р»РёС‚СЂР°
  colors: {
    // РћСЃРЅРѕРІРЅС‹Рµ С†РІРµС‚Р°
    primary: string;        // РћСЃРЅРѕРІРЅРѕР№ Р°РєС†РµРЅС‚РЅС‹Р№ С†РІРµС‚
    primarySoft: string;    // РњСЏРіРєРёР№ РІР°СЂРёР°РЅС‚ РѕСЃРЅРѕРІРЅРѕРіРѕ
    secondary: string;      // Р’С‚РѕСЂРёС‡РЅС‹Р№ Р°РєС†РµРЅС‚
    
    // Р¤РѕРЅС‹
    bgDark: string;         // РўС‘РјРЅС‹Р№ С„РѕРЅ
    bgElevated: string;     // РџСЂРёРїРѕРґРЅСЏС‚С‹Р№ С„РѕРЅ (РєР°СЂС‚РѕС‡РєРё)
    bgInput: string;        // Р¤РѕРЅ РґР»СЏ РёРЅРїСѓС‚РѕРІ
    
    // РўРµРєСЃС‚
    textPrimary: string;    // РћСЃРЅРѕРІРЅРѕР№ С‚РµРєСЃС‚
    textSecondary: string;  // Р’С‚РѕСЂРёС‡РЅС‹Р№ С‚РµРєСЃС‚
    textMuted: string;      // РџСЂРёРіР»СѓС€С‘РЅРЅС‹Р№ С‚РµРєСЃС‚
    
    // Р“СЂР°РЅРёС†С‹ Рё СЌС„С„РµРєС‚С‹
    borderSubtle: string;   // РўРѕРЅРєРёРµ РіСЂР°РЅРёС†С‹
    borderHover: string;    // Р“СЂР°РЅРёС†С‹ РїСЂРё РЅР°РІРµРґРµРЅРёРё
    
    // РЎРїРµС†РёР°Р»СЊРЅС‹Рµ
    success: string;
    error: string;
    warning: string;
  };
  
  // РЁСЂРёС„С‚С‹
  fonts: {
    heading: string;
    body: string;
  };
  
  // РљРѕРЅС‚Р°РєС‚С‹ Рё СЃСЃС‹Р»РєРё
  contacts?: {
    phone?: string;
    address?: string;
    instagram?: string;
    telegram?: string;
    website?: string;
  };
}

// ============================================
// SHERIFF BARBERSHOP - РљРѕРЅС„РёРіСѓСЂР°С†РёСЏ Р±СЂРµРЅРґР°
// ============================================

export const BRAND: BrandConfig = {
  name: 'Sheriff Barbershop',
  tagline: 'РџСЂРµРјРёР°Р»СЊРЅС‹Рµ РјСѓР¶СЃРєРёРµ СЃС‚СЂРёР¶РєРё',
  description: 'AI-РїСЂРёРјРµСЂРєР° РїСЂРёС‡С‘СЃРѕРє, РїРѕРґР±РѕСЂ СЃС‚РёР»СЏ Рё Р·Р°РїРёСЃСЊ Рє РјР°СЃС‚РµСЂР°Рј Sheriff Barbershop',
  
  logos: {
    horizontal: '/assets/sheriff/logo-sheriff-horizontal.png',
    square: '/assets/sheriff/logo-sheriff-square.png',
  },
  
  colors: {
    // Р§С‘СЂРЅРѕ-Р±РµР»Р°СЏ С‚РµРјР° СЃ Р·РѕР»РѕС‚С‹Рј Р°РєС†РµРЅС‚РѕРј
    primary: '#d4af37',           // РўС‘РїР»РѕРµ Р·РѕР»РѕС‚Рѕ
    primarySoft: '#b8962f',       // РџСЂРёРіР»СѓС€С‘РЅРЅРѕРµ Р·РѕР»РѕС‚Рѕ
    secondary: '#8b7355',         // Р‘СЂРѕРЅР·РѕРІС‹Р№ РѕС‚С‚РµРЅРѕРє
    
    // РўС‘РјРЅС‹Рµ С„РѕРЅС‹ (РїРѕС‡С‚Рё С‡С‘СЂРЅС‹Рµ)
    bgDark: '#0a0a0a',            // РћСЃРЅРѕРІРЅРѕР№ С„РѕРЅ
    bgElevated: '#141414',        // РљР°СЂС‚РѕС‡РєРё
    bgInput: '#1a1a1a',           // РРЅРїСѓС‚С‹
    
    // РўРµРєСЃС‚ (Р±РµР»С‹Р№/СЃРµСЂС‹Р№)
    textPrimary: '#ffffff',       // Р‘РµР»С‹Р№
    textSecondary: '#a0a0a0',     // РЎРµСЂС‹Р№
    textMuted: '#666666',         // РџСЂРёРіР»СѓС€С‘РЅРЅС‹Р№
    
    // Р“СЂР°РЅРёС†С‹
    borderSubtle: 'rgba(255, 255, 255, 0.08)',
    borderHover: 'rgba(255, 255, 255, 0.15)',
    
    // РЎС‚Р°С‚СѓСЃС‹
    success: '#22c55e',
    error: '#ef4444',
    warning: '#f59e0b',
  },
  
  fonts: {
    heading: "'Oswald', 'Bebas Neue', 'Impact', sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  
  contacts: {
    // Р—Р°РїРѕР»РЅРёС‚СЊ СЂРµР°Р»СЊРЅС‹РјРё РґР°РЅРЅС‹РјРё РєР»РёРµРЅС‚Р°
    instagram: '@sheriff_barbershop',
    telegram: '@sheriff_barbershop',
  },
};

// Р­РєСЃРїРѕСЂС‚ РѕС‚РґРµР»СЊРЅС‹С… С‡Р°СЃС‚РµР№ РґР»СЏ СѓРґРѕР±СЃС‚РІР°
export const { colors, logos, fonts, name: brandName } = BRAND;

// CSS-РїРµСЂРµРјРµРЅРЅС‹Рµ РґР»СЏ РёСЃРїРѕР»СЊР·РѕРІР°РЅРёСЏ РІ СЃС‚РёР»СЏС…
export const cssVariables = `
  --brand-primary: ${BRAND.colors.primary};
  --brand-primary-soft: ${BRAND.colors.primarySoft};
  --brand-secondary: ${BRAND.colors.secondary};
  --brand-bg: ${BRAND.colors.bgDark};
  --brand-bg-elevated: ${BRAND.colors.bgElevated};
  --brand-bg-input: ${BRAND.colors.bgInput};
  --brand-text: ${BRAND.colors.textPrimary};
  --brand-text-secondary: ${BRAND.colors.textSecondary};
  --brand-text-muted: ${BRAND.colors.textMuted};
  --brand-border: ${BRAND.colors.borderSubtle};
  --brand-border-hover: ${BRAND.colors.borderHover};
`;

